import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

export interface CheckedPhone {
    /** Written the international way ("+968 2412 3456"), or as typed when it can't be read. */
    number: string;
    /** A real number for its country. */
    valid: boolean;
    /** Typed without a country code: the code came from where the record is based (predicted). */
    local: boolean;
}

/**
 * A phone as typed, checked and written the international way — "2412 3456"
 * for a provider based in Oman is "+968 2412 3456". Read on this computer by
 * the free libphonenumber-js; nothing is sent anywhere.
 * @param raw - The number as written.
 * @param country - The ISO 2 code of where the record is based, for a number typed without its country code.
 * @returns The number checked, or null when it isn't a phone at all.
 */
export const checkPhone = (raw: string, country?: string | null): CheckedPhone | null => {
    const typed = String(raw ?? "").trim();
    const digits = typed.replace(/\D/g, "");
    if (digits.length < 6) return null;
    const written = typed.replace(/^00(?=\d)/, "+");
    const local = !written.startsWith("+");
    const code = country && /^[A-Za-z]{2}$/.test(country) ? (country.toUpperCase() as CountryCode) : undefined;
    try {
        const parsed = parsePhoneNumberFromString(written, code);
        if (!parsed) return { number: typed, valid: false, local };
        return { number: parsed.formatInternational(), valid: parsed.isValid(), local: local && !!code };
    } catch {
        return { number: typed, valid: false, local };
    }
};
